import { useQuery, UseQueryOptions } from "react-query";

import { SimpleGetParams } from "../types";

import {
  getArticlesList,
  getDocumentsTypes,
  getEmployeesGroups,
  getStorePriceList,
} from "./index";

export const useGetPriceList = () => {
  return useQuery(["get-pricelist"], getStorePriceList);
};

export const useGetArticlesList = (params: SimpleGetParams) => {
  return useQuery(["get-articles-list"], () => getArticlesList(params));
};

export const useGetEmployeesGroups = (
  options?:
    | Omit<UseQueryOptions<any, unknown, any, string[]>, "queryKey" | "queryFn">
    | undefined
) => {
  return useQuery(["get-employees-groups"], getEmployeesGroups, options);
};

export const useGetDocumentsTypes = () => {
  return useQuery(["get-documents-types"], getDocumentsTypes);
};
